import { Document } from '@contentful/rich-text-types'
import React from 'react'

import { LibraryPostBlockBase } from '../types'
import Caption from '../Caption'

import { Wrapper, EmbedWrapper } from './styles'

export type LibraryPostBlockEmbed = LibraryPostBlockBase<
  'blogPostEmbed',
  {
    caption: Document
    code: string
  }
>

type Props = {
  caption?: Document
  children: string
}

const LibraryPostBlockEmbed: React.FC<Props> = ({ caption, children }) => (
  <Wrapper>
    <EmbedWrapper>
      <div dangerouslySetInnerHTML={{ __html: children }} />
    </EmbedWrapper>
    {caption && <Caption>{caption}</Caption>}
  </Wrapper>
)

export default LibraryPostBlockEmbed
